import { application } from "./application";
import SortableController from "./sortable_controller";
import ImageGalleryController from "./image_gallery_controller";
import SelectFilteringController from "./select_filtering";


application.register("sortable", SortableController);
application.register("image-gallery", ImageGalleryController);
application.register("select-filtering", SelectFilteringController);
